import { render, staticRenderFns } from "./warehouseallocation.vue?vue&type=template&id=249fc9a2&"
import script from "./warehouseallocation.vue?vue&type=script&lang=js&"
export * from "./warehouseallocation.vue?vue&type=script&lang=js&"
import style0 from "./warehouseallocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports